// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveItemTemplateHeaderMutationVariables = Types.Exact<{
  input: Types.SaveItemTemplateInput;
}>;


export type SaveItemTemplateHeaderMutation = { __typename?: 'Mutation', saveItemTemplate: { __typename?: 'SaveItemTemplateResult', itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string, appliedToCount: number, version: string, displayVersion: string, scopeChangeReasonNote?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], activatedAt?: Types.Scalars['DateTime']['input'] | null | undefined, contingencyMarkupPercentage?: number | null | undefined, hasContingencyLineItem: boolean, isUnderwritingTemplate: boolean, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplate', id: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, collection?: { __typename?: 'ItemTemplateCollection', id: string, templates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string, version: string, displayVersion: string, createdAt: Types.Scalars['DateTime']['input'], isUnderwritingTemplate: boolean, lastUsedAsUnderwritingTemplate?: Types.Scalars['Date']['input'] | null | undefined, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string } }> } | null | undefined, statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type SaveScopeTemplateHeader_ReadyPlanMutationVariables = Types.Exact<{
  input: Types.SaveReadyPlanInput;
}>;


export type SaveScopeTemplateHeader_ReadyPlanMutation = { __typename?: 'Mutation', saveReadyPlan: { __typename?: 'SaveReadyPlanResult', readyPlan: { __typename?: 'ReadyPlan', id: string, itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, isUnderwritingTemplate: boolean }> } } };

export type ScopeTemplateHeader_ItemTemplateFragment = { __typename?: 'ItemTemplate', id: string, displayName: string, appliedToCount: number, version: string, displayVersion: string, scopeChangeReasonNote?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], activatedAt?: Types.Scalars['DateTime']['input'] | null | undefined, contingencyMarkupPercentage?: number | null | undefined, hasContingencyLineItem: boolean, isUnderwritingTemplate: boolean, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplate', id: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, collection?: { __typename?: 'ItemTemplateCollection', id: string, templates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string, version: string, displayVersion: string, createdAt: Types.Scalars['DateTime']['input'], isUnderwritingTemplate: boolean, lastUsedAsUnderwritingTemplate?: Types.Scalars['Date']['input'] | null | undefined, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string } }> } | null | undefined, statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const ScopeTemplateHeader_ItemTemplateFragmentDoc = gql`
    fragment ScopeTemplateHeader_ItemTemplate on ItemTemplate {
  id
  displayName
  appliedToCount
  version
  displayVersion
  scopeChangeReason {
    id
    name
  }
  scopeChangeReasonNote
  createdAt
  activatedAt
  basedOn {
    id
  }
  readyPlan {
    id
  }
  canCreateNewVersion {
    ...PotentialOperationDetails
  }
  collection {
    id
    templates {
      id
      displayName
      version
      displayVersion
      createdAt
      isUnderwritingTemplate
      lastUsedAsUnderwritingTemplate
      scopeChangeReason {
        id
        name
      }
      statusDetail {
        code
        name
      }
    }
  }
  statusDetail {
    code
    name
  }
  canDelete {
    ...PotentialOperationDetails
  }
  contingencyMarkupPercentage
  hasContingencyLineItem
  isUnderwritingTemplate
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const SaveItemTemplateHeaderDocument = gql`
    mutation SaveItemTemplateHeader($input: SaveItemTemplateInput!) {
  saveItemTemplate(input: $input) {
    itemTemplate {
      ...ScopeTemplateHeader_ItemTemplate
    }
  }
}
    ${ScopeTemplateHeader_ItemTemplateFragmentDoc}`;
export type SaveItemTemplateHeaderMutationFn = Apollo.MutationFunction<SaveItemTemplateHeaderMutation, SaveItemTemplateHeaderMutationVariables>;

/**
 * __useSaveItemTemplateHeaderMutation__
 *
 * To run a mutation, you first call `useSaveItemTemplateHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemTemplateHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemTemplateHeaderMutation, { data, loading, error }] = useSaveItemTemplateHeaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemTemplateHeaderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemTemplateHeaderMutation, SaveItemTemplateHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemTemplateHeaderMutation, SaveItemTemplateHeaderMutationVariables>(SaveItemTemplateHeaderDocument, options);
      }
export type SaveItemTemplateHeaderMutationHookResult = ReturnType<typeof useSaveItemTemplateHeaderMutation>;
export type SaveItemTemplateHeaderMutationResult = Apollo.MutationResult<SaveItemTemplateHeaderMutation>;
export type SaveItemTemplateHeaderMutationOptions = Apollo.BaseMutationOptions<SaveItemTemplateHeaderMutation, SaveItemTemplateHeaderMutationVariables>;
export const SaveScopeTemplateHeader_ReadyPlanDocument = gql`
    mutation SaveScopeTemplateHeader_ReadyPlan($input: SaveReadyPlanInput!) {
  saveReadyPlan(input: $input) {
    readyPlan {
      id
      itemTemplates {
        id
        isUnderwritingTemplate
      }
    }
  }
}
    `;
export type SaveScopeTemplateHeader_ReadyPlanMutationFn = Apollo.MutationFunction<SaveScopeTemplateHeader_ReadyPlanMutation, SaveScopeTemplateHeader_ReadyPlanMutationVariables>;

/**
 * __useSaveScopeTemplateHeader_ReadyPlanMutation__
 *
 * To run a mutation, you first call `useSaveScopeTemplateHeader_ReadyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScopeTemplateHeader_ReadyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScopeTemplateHeaderReadyPlanMutation, { data, loading, error }] = useSaveScopeTemplateHeader_ReadyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScopeTemplateHeader_ReadyPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScopeTemplateHeader_ReadyPlanMutation, SaveScopeTemplateHeader_ReadyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScopeTemplateHeader_ReadyPlanMutation, SaveScopeTemplateHeader_ReadyPlanMutationVariables>(SaveScopeTemplateHeader_ReadyPlanDocument, options);
      }
export type SaveScopeTemplateHeader_ReadyPlanMutationHookResult = ReturnType<typeof useSaveScopeTemplateHeader_ReadyPlanMutation>;
export type SaveScopeTemplateHeader_ReadyPlanMutationResult = Apollo.MutationResult<SaveScopeTemplateHeader_ReadyPlanMutation>;
export type SaveScopeTemplateHeader_ReadyPlanMutationOptions = Apollo.BaseMutationOptions<SaveScopeTemplateHeader_ReadyPlanMutation, SaveScopeTemplateHeader_ReadyPlanMutationVariables>;